import recordLayout from 'Shared/helpers/recordLayout';

const initialState = { active: false };

export function salesforce_record_modal(state = initialState, action) {
  switch (action.type) {
    case 'CLOSE_SALESFORCE_RECORD_MODAL':
      return {
        active: false,
      };
    case 'OPEN_SALESFORCE_RECORD_MODAL':
      return {
        active: true,
        error: { ...(action.record_errors || [])[0], errors: action.record_errors || [] },
        record: recordLayout.getLayoutModelForDefaults(action.modal),
        picklists: action.picklists,
        recommendation_id: action.recommendation_id,
        button_key: action.button_key,
        mode: 'Create',
      };
    case 'UPDATE_SALESFORCE_RECORD_MODAL_FIELD_VALUE': {
      const oldEditValue = state.record.editValues[action.field];
      const newEditValue = {
        ...oldEditValue,
        current: action.value,
      };

      const updateMap = {};
      updateMap[action.field] = newEditValue;

      const newEditValues = Object.assign({}, state.record.editValues, updateMap);

      return {
        ...state,
        record: {
          ...state.record,
          editValues: newEditValues,
        },
      };
    }
    default:
      return state;
  }
}
